import styled from '@emotion/styled/macro';

export const HubWrapper = styled.div`
    width: 100%;
    max-width: 987px;
    margin: 0 auto;
    padding: 24px 16px;
    box-sizing: border-box;
`;

export const HubSubtitle = styled.p`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
    color: ${props => props.theme.colours.textDark};
    text-align: center;
    margin: 0 0 32px 0;
`;

export const ErrorText = styled.p`
    text-align: center;
    color: #dc3545;
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
`;

export const EmptyText = styled.p`
    text-align: center;
    color: ${props => props.theme.colours.textDark};
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
    padding: 48px 0;
`;

export const CardGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    width: 100%;
    justify-content: center;

    @media (max-width: ${props => props.theme.widths.tabletMax}) {
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: ${props => props.theme.widths.mobileMax}) {
        flex-direction: column;
    }
`;
